import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

const inputCls =
  "w-full border border-border bg-forest-deep/70 px-4 py-3 text-sm text-bone placeholder:text-sand/40 outline-none transition-colors focus:border-brass";

export const BIKE_OPTIONS = [
  "Sur-Ron Light Bee X",
  "Talaria Sting R",
  "HitWay BK-U1 (road legal)",
  "HitWay BK15 4.0 (road legal)",
  "OSET 12.5 Racing",
  "OSET 16.0 Racing",
  "OSET 20.0 Racing",
  "Accessories / gear",
  "Bundle deal",
  "Not sure yet — advise me",
];

export const EnquiryForm = ({ bike = "", testPrefix = "enquiry-form" }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", bike, message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", {
        name: form.name,
        email: form.email,
        phone: form.phone,
        country: "",
        model_interest: form.bike,
        message: form.message,
      });
      setSent(true);
      toast.success("Enquiry sent — we reply within one working day");
    } catch {
      toast.error("Could not send — please retry or call 07522 364950.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div data-testid={`${testPrefix}-success`} className="flex flex-col items-center py-10 text-center">
        <CheckCircle2 className="h-12 w-12 text-volt" strokeWidth={1.25} />
        <p className="mt-4 font-serif text-2xl font-bold uppercase text-bone">Enquiry received</p>
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-sand">
          We'll come back within one working day with latest pricing and next pre-order slots.
        </p>
      </div>
    );
  }

  return (
    <form data-testid={`${testPrefix}`} onSubmit={submit} className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <input
          data-testid={`${testPrefix}-name-input`}
          required
          placeholder="Name"
          value={form.name}
          onChange={set("name")}
          className={inputCls}
        />
        <input
          data-testid={`${testPrefix}-email-input`}
          required
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={set("email")}
          className={inputCls}
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <input
          data-testid={`${testPrefix}-phone-input`}
          type="tel"
          placeholder="Phone (optional)"
          value={form.phone}
          onChange={set("phone")}
          className={inputCls}
        />
        {bike ? (
          <input
            data-testid={`${testPrefix}-bike-input`}
            readOnly
            value={form.bike}
            className={`${inputCls} cursor-default text-cyanx`}
          />
        ) : (
          <select
            data-testid={`${testPrefix}-bike-select`}
            required
            value={form.bike}
            onChange={set("bike")}
            className={`${inputCls} appearance-none`}
          >
            <option value="">Which bike?…</option>
            {BIKE_OPTIONS.map((b) => (
              <option key={b}>{b}</option>
            ))}
          </select>
        )}
      </div>
      <textarea
        data-testid={`${testPrefix}-message-input`}
        required
        rows={3}
        placeholder="Message — pricing, colours, bundle deals…"
        value={form.message}
        onChange={set("message")}
        className={`${inputCls} resize-none`}
      />
      <button
        data-testid={`${testPrefix}-submit-button`}
        disabled={loading}
        className="clip-corner-sm w-full bg-brass py-3.5 font-mono text-[11px] font-bold tracking-[0.2em] text-white uppercase transition-colors hover:bg-brass-bright disabled:opacity-50"
      >
        {loading ? "Sending…" : "Send Enquiry"}
      </button>
      <p className="text-center font-mono text-[9px] tracking-[0.12em] text-sand/50 uppercase">
        Or call 07522 364950 · ecobikecampsupp@gmail.com
      </p>
    </form>
  );
};
